import { useNavigate } from 'react-router-dom'

/**
 * Nút quay lại của các màn hình bộ Modern.
 *
 * To và có chữ, không phải một mũi tên bé xíu. Người dùng của app này 45–60 tuổi, bấm
 * bằng ngón cái trên màn hình cảm ứng ở quán thiếu sáng — một cái mũi tên 20px là thứ họ
 * bấm trượt ba lần rồi thôi, và khi đã không tìm được đường về thì họ tắt app đi.
 *
 * Chiều cao đúng 56px như mọi nút chính khác trong app.
 */
export function PageBack({ to, label = 'Quay lại' }: { to: string; label?: string }) {
  const nav = useNavigate()

  return (
    <button type="button" className="page-back" onClick={() => nav(to)}>
      <span className="page-back-arrow" aria-hidden="true">
        ‹
      </span>
      <span className="page-back-text">{label}</span>
    </button>
  )
}
